import PlayCircleFilledRounded from '@material-ui/icons/PlayCircleFilledRounded';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import {
  Admin,
  Analytics,
  Managment,
  Monitoring,
  Operations,
} from 'assets/icons';

export const SECTIONS = [
  {
    id: 'GET_STARTED',
    Icon: PlayCircleFilledRounded,
    labelKey: 'get_started',
    descKey: 'get_started_description',
    popularKeys: [
      'ask_manual_popular_get_started_first_steps',
      'ask_manual_popular_get_started_change_password',
      'ask_manual_popular_get_started_switch_language',
    ],
  },
  {
    id: 'MONITORING',
    Icon: Monitoring,
    labelKey: 'monitoring',
    descKey: 'monitoring_description',
    popularKeys: [
      'ask_manual_popular_monitoring_guards_on_shift',
      'ask_manual_popular_monitoring_handle_alarm',
      'ask_manual_popular_monitoring_gps_false_alert',
    ],
  },
  {
    id: 'OPERATIONS',
    Icon: Operations,
    labelKey: 'operations',
    descKey: 'operations_description',
    popularKeys: [
      'ask_manual_popular_operations_create_incident',
      'ask_manual_popular_operations_register_visitor',
      'ask_manual_popular_operations_client_report',
    ],
  },
  {
    id: 'ANALYTICS',
    Icon: Analytics,
    labelKey: 'analytics',
    descKey: 'analytics_description',
    popularKeys: [
      'ask_manual_popular_analytics_past_shift',
      'ask_manual_popular_analytics_review_hours',
      'ask_manual_popular_analytics_guard_performance',
      'ask_manual_popular_analytics_bi_export',
    ],
  },
  {
    id: 'MANAGEMENT',
    Icon: Managment,
    labelKey: 'management',
    descKey: 'management_description',
    popularKeys: [
      'ask_manual_popular_management_add_site',
      'ask_manual_popular_management_add_employee',
      'ask_manual_popular_management_create_tour',
      'ask_manual_popular_management_setup_gps',
    ],
  },
  {
    id: 'ADMIN',
    Icon: Admin,
    labelKey: 'admin',
    descKey: 'admin_description',
    popularKeys: [
      'ask_manual_popular_admin_build_form',
      'ask_manual_popular_admin_system_log',
      'ask_manual_popular_admin_incident_fields',
      'ask_manual_popular_admin_branches',
    ],
  },
  {
    id: 'INFORMATION',
    Icon: InfoOutlined,
    labelKey: 'information',
    descKey: 'information_description',
    popularKeys: [
      'ask_manual_popular_information_whats_new',
      'ask_manual_popular_information_read_terms',
      'ask_manual_popular_information_help_chat',
    ],
  },
];

export const sectionById = (id) => SECTIONS.find((s) => s.id === id) || SECTIONS[0];
